import React, { FC, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, TypographyTagVariants } from '@components/atoms/Typography';
import { Form } from '@components/atoms/Form';
import { useData } from '@hooks/useData';
import { useLogout } from '@services/useLogout';
import { useNavigate } from 'react-router-dom';

export const LogoutForm: FC = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { request: requestLogout, loading, lastResponseTime } = useLogout();
    const { login } = useData();

    const translations = {
        exit: t('user-area.exit'),
    };

    const formRef = useRef<HTMLFormElement>(null);

    const handleOnClickLogout = () => {
        formRef?.current?.requestSubmit();
    };

    const submitForm = () => {
        requestLogout();
    };

    // if logged out successfully, go to homepage
    useEffect(() => {
        if (lastResponseTime !== null && login === null) {
            navigate('/login');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lastResponseTime]);

    return (
        <Form formRef={formRef} classes="d-flex flex-column" onSubmit={submitForm}>
            <span
                onClick={handleOnClickLogout}
                style={{
                    cursor: loading ? 'default' : 'pointer',
                    opacity: loading ? 0.5 : 1,
                }}>
                <Typography fontSize="16" fontWeight="300" color="dark">
                    <>
                        <Typography fontWeight="300" tagVariant={TypographyTagVariants.span}>
                            <i style={{ marginRight: '5px' }} className="fa-thin fa-arrow-right-from-bracket"></i>
                        </Typography>
                        {` ${translations.exit}`}
                    </>
                </Typography>
            </span>
        </Form>
    );
};
